import { Realm } from './constants';

const realmToShard = (realm: Realm): string => {
  switch (realm) {
    case 'us':
      return 'us';
    default:
      return 'eu';
  }
};

export default realmToShard;
